import React, { FC, useState } from 'react';
import CustomModal from '../../components/CustomModal';
import useTranslation from '../../hooks/useTranslation';
import ProjectForm from '../../components/ProjectForm/index';
import FormatChangeTabs from '../../components/FormatChangeTabs';
import { ProjectTypeModalProps } from '../../models/reusableProps/ProjectTypeModalProps';
import { useTypedSelector } from '../../store';
import { selectResponsibleOptionsList } from '../../store/users/selectors';
import {
  getBusinessUnits,
  getSelectedCountryCodes,
} from '../../store/selectData/selectors';
import { ESTABLISHMENT_TYPE } from '../../components/ProjectTypeSelect/utils';
import { selectConfidentialPermission } from '../../store/userData/selectors';
import {
  createProject,
  fetchSiteLocation,
} from '../../store/projects/actionWrapper';
import { useDispatch } from 'react-redux';
import {
  selectSiteLocation,
  selectSolutions,
} from '../../store/projects/selectors';
import { returnFormatChangeValidationSchema } from './utils';
import { calculateTabErrors } from '../CreateNewUnitModal/utils';
import { stripOfNewId } from '../BulkCreate/utils';

const FormatChangeModal: FC<ProjectTypeModalProps> = ({
  visible,
  onClose,
  projectsList,
  countries,
  setActiveProject,
}) => {
  const t = useTranslation();
  const isConfidentialAllowed = useTypedSelector(selectConfidentialPermission);
  const usersList = useTypedSelector(selectResponsibleOptionsList);
  const BuList = useTypedSelector(getBusinessUnits);
  const selectedCountryCodes = useTypedSelector(getSelectedCountryCodes);
  const solutions = useTypedSelector(selectSolutions);
  const selectedSiteLocation = useTypedSelector(selectSiteLocation);
  const [formModified, setFormModified] = React.useState(false);
  const [selectedCountry, setSelectedCountry] = React.useState('');
  const validation = returnFormatChangeValidationSchema(t);
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState({});

  const handleCreateProject = (props) => {
    dispatch(
      createProject({
        ...props,
        solutions: solutions.map(stripOfNewId),
        establishmentType: ESTABLISHMENT_TYPE.FORMAT_CHANGE,
      }),
    );
    onClose();
  };

  const onCountryChange = (country) => {
    setSelectedCountry(country.target.value);
  };

  const BuFiltered = BuList.filter(
    (bu) =>
      bu.countryId === (selectedCountry || selectedCountryCodes[0]?.countryId),
  );
  const onBUChange = (bu) => {
    dispatch(fetchSiteLocation(bu.businessUnitId || ''));
  };
  return (
    <CustomModal
      isVisible={visible}
      onClose={onClose}
      formModified={formModified}
      title={t('projectTypes.formatChange')}
      useConfirmation
      children={
        <ProjectForm
          onSubmit={handleCreateProject}
          setFormModified={(isDirty) => setFormModified(isDirty)}
          country={selectedCountryCodes[0]?.countryId || ''}
          onClose={onClose}
          submitBtnTitle={t('common.create')}
          validationSchema={validation}
          projectType={ESTABLISHMENT_TYPE.FORMAT_CHANGE}
          selectedSiteLocation={selectedSiteLocation}
          setFormErrors={setFormErrors}
        >
          <FormatChangeTabs
            projectsList={projectsList}
            countries={countries}
            setActiveProject={setActiveProject}
            usersList={usersList}
            isConfidentialAllowed={isConfidentialAllowed}
            onCountryChange={onCountryChange}
            onBUChange={onBUChange}
            BuList={BuFiltered}
            tabErrors={calculateTabErrors(formErrors, false)}
          />
        </ProjectForm>
      }
    />
  );
};

export default FormatChangeModal;
